import React from "react"
import SbEditable from "storyblok-react"
import { render } from "storyblok-rich-text-react-renderer"

const RichText = ({blok}) => {
  return <SbEditable content={blok} key={blok._uid}>
    <div>{render(blok.text)}</div>
  </SbEditable>
}

export default RichText